"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.player = exports.server = void 0;
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
const chalk_1 = __importDefault(require("chalk"));
const timeStarted = Math.floor(Date.now() / 1000).toString();
const isInNode = typeof process !== 'undefined' && !process.browser && process.platform !== 'browser' && !globalThis.__hot_reload;
const _servers = [];
let readline;
let rl;
if (isInNode) {
    Promise.resolve().then(() => __importStar(require(/* webpackIgnore: true */ 'exit-hook'))).then((hook) => {
        hook.default(() => {
            // todo fix, instead use double ctrl+c
            setTimeout(() => {
                console.log('Forcefully shutting down...');
                process.exit(0);
            }, 2000);
            for (const serv of _servers) {
                serv.log('Server shutting down...');
                serv.quit();
            }
        });
    });
    readline = require('readline');
    rl = readline.createInterface({
        input: process.stdin,
        output: process.stdout
    });
    rl.setPrompt('> ');
    rl.prompt(true);
}
const server = function (serv, settings) {
    _servers.push(serv);
    serv.on('error', error => serv.err('Server: ' + error.stack));
    serv.on('clientError', (client, error) => {
        if (error.message.includes('ECONNABORTED'))
            return;
        serv.err('Client ' + client.socket?.remoteAddress + ':' + client.socket.remotePort + ' : ' + error.stack);
    });
    serv.on('listening', port => serv.info('Server listening on port ' + port));
    serv.on('banned', (banner, bannedUsername, reason) => serv.info(banner.username + ' banned ' + bannedUsername + (reason ? ' (' + reason + ')' : '')));
    serv.on('seed', (seed) => serv.info('World seed: ' + seed));
    const logFile = path_1.default.join('logs', timeStarted + '.log');
    serv.log = message => {
        readline?.cursorTo(process.stdout, 0);
        let date = new Date();
        let formattedDate = `${date.toLocaleString('default', { month: 'long' })} ${date.getDate()} ${date.getFullYear()}, ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
        message = formattedDate + ' ' + message; // todo use intl
        message = serv.formatMessage?.(message) ?? message;
        if (!message)
            return;
        if (!settings.noConsoleOutput)
            console.log(message);
        if (!settings.logging)
            return;
        fs_1.default.appendFile(logFile, message + '\n', (err) => {
            if (err)
                console.log(err);
        });
    };
    serv.info = message => {
        serv.log('[' + chalk_1.default.green('INFO') + ']: ' + message);
    };
    serv.err = message => {
        serv.log('[' + chalk_1.default.red('ERROR') + ']: ' + message);
    };
    serv.warn = message => {
        serv.log('[' + chalk_1.default.yellow('WARN') + ']: ' + message);
    };
    if (isInNode) {
        console.log = (function () {
            const orig = console.log;
            return function () {
                readline.cursorTo(process.stdout, 0);
                // let tmp
                // try {
                //   tmp = process.stdout
                //   // @ts-ignore
                //   process.stdout = process.stderr
                //   orig.apply(console, arguments)
                // } finally {
                //   process.stdout = tmp
                // }
                orig.apply(console, arguments);
                rl.prompt(true);
            };
        })();
    }
    serv.createLog = () => {
        if (!settings.logging)
            return;
        fs_1.default.mkdir('logs', {
            recursive: true
        }, (err) => {
            if (err) {
                console.log(err);
                return;
            }
            fs_1.default.writeFile(logFile, '[INFO]: Started logging...\n', (err) => {
                if (err)
                    console.log(err);
            });
        });
    };
    // todo fix hotreload
    rl?.on('line', (data) => {
        serv.handleCommand(data);
        rl.prompt(true);
    });
};
exports.server = server;
const player = function (player, serv) {
    player.on('connected', () => serv.info(player.username + ' (' + player._client.socket?.remoteAddress + ') connected'));
    player.on('spawned', () => serv.info('Position written, spawning player...'));
    player.on('disconnected', (reason) => serv.info(player.username + ' disconnected. Reason: ' + reason));
    // player.on('chat', ({ message }) => serv.info('<' + player.username + '>' + ' ' + message))
    player.on('kicked', (kicker, reason) => serv.info(kicker.username + ' kicked ' + player.username + (reason ? ' (' + reason + ')' : '')));
};
exports.player = player;
